import { API, Endpoints } from '@brg/api';
import { translateStrangeObject } from 'shared/helpers/translateStrangeObject';

export type FtblCurrentClub = {
  teamId: string;
  name: string;
};

export const fetchCurrentFtblClub = async (accountId: string, lang: string): Promise<FtblCurrentClub | null> => {
  const response = await API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/GetCurrentFTBLCub')
    .addQuery('accountId', accountId)
    .get()
    .send();

  if (response.status === 204) {
    return null;
  }

  const text = await response.text();

  if (!text.trim()) {
    return null;
  }

  let data: { teamId?: string; name?: string };

  try {
    data = JSON.parse(text);
  } catch {
    return null;
  }

  if (!data?.teamId) {
    return null;
  }

  return {
    teamId: data.teamId,
    name: translateStrangeObject(data?.name, lang.toLowerCase()) || '',
  };
};
import { API, Endpoints } from '@brg/api';
import { translateStrangeObject } from 'shared/helpers/translateStrangeObject';

export type FtblCurrentClub = {
  teamId: string;
  name: string;
};

export const fetchCurrentFtblClub = async (accountId: string, lang: string): Promise<FtblCurrentClub | null> => {
  const response = await API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/GetCurrentFTBLCub')
    .addQuery('accountId', accountId)
    .get()
    .send();

  if (response.status === 204) {
    return null;
  }

  const text = await response.text();

  if (!text.trim()) {
    return null;
  }

  let data: { teamId?: string; name?: string };

  try {
    data = JSON.parse(text);
  } catch {
    return null;
  }

  if (!data?.teamId) {
    return null;
  }

  return {
    teamId: data.teamId,
    name: translateStrangeObject(data?.name, lang.toLowerCase()) || '',
  };
};
